import React from "react";
import { Layout, Menu, Button } from "antd";
import { Outlet, useNavigate, useLocation } from "react-router";
import {
  DashboardOutlined,
  FileTextOutlined,
  LogoutOutlined,
} from "@ant-design/icons";
import "./AdminLayout.css";

const { Header, Sider, Content } = Layout;

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    // {
    //   key: "/admin",
    //   icon: <DashboardOutlined />,
    //   label: "Dashboard",
    // },
    {
      key: "/admin",
      icon: <FileTextOutlined />,
      label: "News Management",
    },
  ];

  const handleLogout = () => {
    // Clear authentication (Example: remove token)
    localStorage.removeItem("adminToken");
    navigate("/login"); // Redirect to login page
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      {/* Sidebar Navigation */}
      <Sider collapsible>
        <div className="admin-logo">Admin Panel</div>
        <Menu
          theme="dark"
          mode="inline"
          defaultSelectedKeys={location.pathname}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
        />
      </Sider>

      {/* Main Content Area */}
      <Layout>
        <Header className="admin-header">
          <Button
            className="button"
            icon={<LogoutOutlined />}
            onClick={handleLogout}
          >
            Logout
          </Button>
        </Header>
        <Content className="admin-content">
          <Outlet /> {/* This renders nested admin pages */}
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
